import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/inventory.svg';

import styles from './InventoryIcon.styles';

type InventoryIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'InventoryIcon' });

export default function InventoryIcon({ className }: InventoryIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.icon, className)}>
      <Icon />
    </span>
  );
}
